import { useState } from "react";
import { Link } from "react-router-dom";
import { apiClient } from "@/services/httpClient";

export default function ForgotPassword({ t }) {
  const copy = t?.forgotPasswordPage || {};
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    setMessage("");
    setStatus("loading");

    try {
      const response = await apiClient.post("/api/auth/forgot-password", {
        email: email.trim(),
      });

      if (response.status >= 200 && response.status < 300) {
        setStatus("success");
        setMessage(
          copy.success || "Si un compte correspond à cette adresse, un email de réinitialisation a été envoyé."
        );
        return;
      }

      setStatus("error");
      setMessage(
        copy.requestError || "Impossible d'envoyer la demande pour le moment. Veuillez réessayer."
      );
    } catch (error) {
      console.error("[ForgotPassword] Request failed:", error);
      setStatus("error");
      setMessage(
        copy.genericError || "Une erreur est survenue. Veuillez réessayer."
      );
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-700 via-slate-600 to-slate-700 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-xl shadow-sm p-6">
        <div className="text-center mb-6">
          <img
            src="/assets/hearen-logo-final.png"
            alt="Hearen"
            className="h-28 w-auto object-contain mx-auto mb-2"
            style={{
              filter: "brightness(1.1) hue-rotate(15deg) saturate(1.1)",
            }}
          />

          <h1 className="text-2xl font-semibold text-blue-600">
            {copy.title || "Mot de passe oublié"}
          </h1>

          <p className="text-gray-500 mt-2">
            {copy.intro || "Entrez votre adresse email pour recevoir un lien de réinitialisation."}
          </p>
        </div>

        {status === "success" ? (
          <div className="text-center">
            <p className="text-gray-700">{message}</p>

            <Link
              to="/login"
              className="inline-block mt-6 text-blue-600 hover:underline font-medium"
            >
              {copy.back || "Retour à la connexion"}
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <label
                htmlFor="email"
                className="text-sm font-medium"
              >
                Email
              </label>

              <input
                id="email"
                type="email"
                autoComplete="email"
                placeholder={copy.placeholder || "votre@email.com"}
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                className="w-full rounded-md border border-gray-300 px-3 py-2 placeholder:text-gray-400"
                style={{
                  backgroundColor: "#ffffff",
                  color: "#000000",
                  WebkitTextFillColor: "#000000",
                }}
                required
              />
            </div>

            {message && (
              <div className="text-sm text-red-600">
                {message}
              </div>
            )}

            <button
              type="submit"
              disabled={status === "loading"}
              className="w-full rounded-md bg-slate-950 text-white py-3 font-medium disabled:opacity-60"
            >
              {status === "loading"
                ? (copy.loading || "Envoi…")
                : (copy.submit || "Envoyer le lien de réinitialisation")}
            </button>

            <div className="text-center text-sm">
              <Link
                to="/login"
                className="text-blue-600 hover:underline font-medium"
              >
                {copy.back || "Retour à la connexion"}
              </Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
